/**
 * JACK ROYALS – Compliance Word Filter
 * Replaces gambling terms with sweepstakes-safe language.
 * Used across all user-facing text in the application.
 */

const bannedTerms = {
  "casino": "sweepstakes entertainment",
  "gamble": "play",
  "gambling": "sweepstakes participation",
  "betting": "participation",
  "wagering": "participation",
  "wager": "entry",
  "wagers": "entries",
  "bets": "entries",
  "bet": "enter",
  "stake": "entry",
  "stakes": "entries",
  "deposit": "purchase",
  "deposits": "purchases",
  "withdraw": "redeem",
  "withdrawal": "prize redemption",
  "withdrawals": "prize redemptions",
  "cashout": "prize redemption",
  "cash out": "prize redemption",
  "payout": "prize fulfillment",
  "payouts": "prize fulfillment",
  "real money": "virtual coins",
  "jackpot": "grand prize",
  "jackpots": "grand prizes",
  "odds": "chances",
  "house edge": "game structure",
  "RTP": "game structure"
};

// Pre-compile regexes for performance
const compiledTerms = Object.entries(bannedTerms).map(([term, replacement]) => ({
  regex: new RegExp(`\\b${term}\\b`, "gi"),
  replacement
}));

// Context-aware: "slots" -> "games" but NOT "slot games" (already fine)
const contextTerms = [
  { regex: /\bslots\b(?!\s+games)/gi, replacement: "games" },
  { regex: /\bslot\b(?!\s+games?)/gi, replacement: "game" },
];

export function sanitizeText(input) {
  if (!input || typeof input !== "string") return input;
  let output = input;
  for (const { regex, replacement } of compiledTerms) {
    output = output.replace(regex, replacement);
  }
  for (const { regex, replacement } of contextTerms) {
    output = output.replace(regex, replacement);
  }
  return output;
}

export default sanitizeText;
